import TextWithIcon from "../../common/TextWithIcon";
import companyData from "./P3CompaniesContactInfo";

export const ContactInfo = (props) => {
  let { phoneNumber, email, site, campaignDetails } = props;
  let phoneNumber1, phoneNumber2, phoneSchedule;

  const details =
    campaignDetails &&
    campaignDetails.name &&
    companyData.find((item) => item.campaignName === campaignDetails.name);
  if (details) {
    ({ phoneNumber1, phoneNumber2, phoneSchedule, email, site } = details);
  }

  return (
    <>
      {details ? (
        <>
          <TextWithIcon
            label={phoneNumber1}
            url={`tel:${phoneNumber1}`}
            inlineInfo={props.inlineInfo}
          />
          <TextWithIcon
            label={phoneNumber2}
            url={`tel:${phoneNumber2}`}
            inlineInfo={props.inlineInfo}
          />
          <TextWithIcon
            icon="call.svg"
            label={phoneSchedule}
            inlineInfo={props.inlineInfo}
          />
        </>
      ) : (
        <TextWithIcon
          icon="call.svg"
          label={phoneNumber}
          url={`tel:${phoneNumber}`}
          bold={true}
          inlineInfo={props.inlineInfo}
        />
      )}
      <TextWithIcon
        icon="mail.svg"
        label={email}
        url={`mailto:${email}`}
        inlineInfo={props.inlineInfo}
      />
      <TextWithIcon
        icon="global.svg"
        label={site}
        url={`https://${site}`}
        inlineInfo={props.inlineInfo}
      />
    </>
  );
};
